module.exports = __webpack_public_path__ + "static/jurassic-park-d64bf2af9fbaceea8546e08073b1482e.jpg";